import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from './user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationSamlService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(sessionStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  callback(userData: string): any {
    // Check if token and username exists
    //console.log('authsaml.service - callback - userData: ', userData);
    let user: User;
    user = JSON.parse(userData);
    //console.log('authsaml.service - callback - user: ', user);
    //console.log('authsaml.service - callback - stringify user: ', JSON.stringify(user));
    if (user && user.id_token) {
      // Save token
      this.storeAuthenticationToken(user);
      this.currentUserSubject.next(user);
    }
    return user;

  }

  callbackToken(tokenCod: string): any {
    //console.log('authsaml.service - callbackToken - tokenCod: ' + tokenCod);
    // Check if token and username exists
    try {
      var token = this.parseJwt(tokenCod);
      //console.log('authsaml.service - callbackToken - token: ', token);
    
      let user : User = new User(token.USERNAME, token.USERNAME, token.auth.split(","), tokenCod, token.exp);
      //console.log('authsaml.service - callbackToken - user: ', user);
      //console.log('authsaml.service - callbackToken - stringify user: ', JSON.stringify(user));

      if (user && user.id_token) {
        // Save token
        this.storeAuthenticationToken(user);
        this.currentUserSubject.next(user);
      }
      return user;
    } catch (error) {
      console.error('No se ha podido procesar/almacenar correctamente el token de autenticación.');
      return null;
    }
  }

  /**
   * Save authentication token into local storage
   * @param jwt token to save in JWT format with key token
   */
  private storeAuthenticationToken(user: User) {
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    sessionStorage.setItem('authenticationToken', user.id_token);
  }

  /**
   * Remove authentication token from local storage
   */
  private removeAuthenticationToken() {
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('authenticationToken');
  }

  // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
  private parseJwt (token: string) {
    //console.log('authsaml.service - parseJwt - token: ' + token);
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    //console.log('authsaml.service - parseJwt - jsonPayload: ' + jsonPayload);
    //console.log('authsaml.service - parseJwt - parsed jsonPayload: ', JSON.parse(jsonPayload));
    return JSON.parse(jsonPayload);
  }
}
